// useLocationModalState — tiny state helper for the map-pin
// "location detail" modal that opens from each property card in the
// booking widget's visual carousel.
//
// Side-effect worth noting: opening the modal for a hotel that is NOT
// yet in the enquiry ALSO adds the hotel as a fresh block, so the card
// stays visually selected while + after the modal is open. Camp
// parents (currently only "Bivouacs La Belle Étoile") are treated as
// pure "info" surfaces here — we don't force-select any camp.
//
// Extracted from `HomeBookingWidget.jsx` — behaviour is 1:1 with the
// original inline handler.

import { useCallback, useState } from "react";
import { getCampsForHotel } from "@/lib/bookingCamps";
import { newBlock } from "@/components/booking/homeBookingWidgetHelpers";

export default function useLocationModalState({ blocks, mutate }) {
  const [locationModalHotel, setLocationModalHotel] = useState(null);

  const openLocationModal = useCallback(
    (hotel) => {
      if (!hotel) return;
      const already = blocks.some((b) => b.slug === hotel.slug);
      if (!already) {
        const camps = getCampsForHotel(hotel.slug);
        if (camps.length === 0) {
          mutate((cur) => [...cur, newBlock(hotel.slug)]);
        }
      }
      setLocationModalHotel(hotel);
    },
    [blocks, mutate]
  );

  const closeLocationModal = useCallback(
    () => setLocationModalHotel(null),
    []
  );

  return { locationModalHotel, openLocationModal, closeLocationModal };
}
